import { call, put, select, takeEvery } from "redux-saga/effects";

import {
  ADD_CLIENT,
  DELETE_CLIENT,
  GET_CLIENT,
  GET_CLIENTS_LIST,
  UPDATE_CLIENT,
} from "./actionTypes";
import {
  hideClientLoader,
  hideClientsListLoader,
  setClient,
  setClientsList,
  setErrorClient,
  showClientLoader,
  showClientsListLoader,
} from "./actions";

import {
  deleteClient,
  getClient,
  getClientsList,
  patchClient,
  pathClientDocument,
  postClient,
  postClientDocuments,
} from "../../helpers/jwt_helper";
import {
  convertDocsToTreeData,
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";

function* onGetClientsList({ payload: data }) {
  try {
    yield put(showClientsListLoader());
    let updData = data;
    let rentStatus =
      data?.offers__is_rent == true ||
      data?.offers__is_rent == false;
    let dt = {
      page: data.page,
      size: 0,
      ordering: data.ordering,
      client: data.client,
      search: data.search,
      status: data.status,
    };

    if (rentStatus) dt.offers__is_rent = data.offers__is_rent;
    if (rentStatus) dt.status = data.status;

    let response = yield call(getClientsList, { ...dt });

    if (rentStatus) delete updData.offers__is_rent;

    if (response.results) {
      response = {
        ...updData,
        ...response,
        results: response.results.map(i => ({
          ...i,
          created_at: new Date(i.created_at).toDateString(),
        })),
      };
    } else {
      response = {
        results: response,
      };
    }

    yield put(setClientsList(response));
    yield put(hideClientsListLoader());
  } catch (error) {
    yield put(hideClientsListLoader());
  }
}

function* onDeleteClient({ payload: { id, data } }) {
  try {
    yield put(showClientsListLoader());
    yield call(deleteClient, id);
    yield call(onGetClientsList, { payload: data });
    yield put(hideClientsListLoader());
    showSuccessMessage(`Client has been deleted successfully`);
  } catch (error) {
    yield put(hideClientsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetClient({ payload: id }) {
  try {
    yield put(showClientLoader());
    let response = yield call(getClient, id);

    response.parsed_docs = convertDocsToTreeData(response.documents_info);

    yield put(setClient(response));
    yield put(setErrorClient(false));
    yield put(hideClientLoader());
  } catch (error) {
    //console.log(error);
    // yield put(setErrorClient(true));
    yield put(hideClientLoader());
  }
}

function* onPatchClient({ payload: { id, data, docs } }) {
  try {
    // debugger
    const client = yield select(state => state.Clients.client);
    const formData = new FormData();
    let path = [],
      ids = [];
    for (const element of docs) {
      if (typeof element.file !== "string") {
        path.push(element.path);
        formData.append("files", element.file);
      } else {
        ids.push(element.id);
        const f = client.documents_info.find(i => i.id === element.id);
        if (f) {
          if (f.prefix !== element.path) {
            const fData = new FormData();
            fData.append("prefix", element.path);
            yield call(pathClientDocument, f.id, fData);
          }
        } else {
        }
      }
    }

    let r = [];
    if (path.length > 0) {
      path = path.join(",");

      formData.append("prefixes", path);

      r = yield call(postClientDocuments, formData);
    }

    data.documents = [...r, ...ids];

    let name = data.legal_name;
    yield put(showClientLoader());
    let res = yield call(patchClient, id, data);
    yield put(hideClientLoader());

    res.parsed_docs = convertDocsToTreeData(res.documents_info);

    yield put(setClient(res));
    showSuccessMessage(`Updating client ${name} has been successfully`);
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
    yield put(hideClientLoader());
  }
}

function* onAddClient({ payload: { data, documents, history } }) {
  try {
    const formData = new FormData();
    documents.forEach(element => {
      formData.append("files", element.file);
    });

    const path = documents.map(i => i.path).join(",");

    formData.append("prefixes", path);

    data.documents = yield call(postClientDocuments, formData);

    const res = yield call(postClient, data);
    yield put(setClient(res));
    showSuccessMessage(`Client ${data.legal_name} successfully created`);
    history.push(`/clients/${res.id}`, {
      was_created: true,
    });
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* clientsSaga() {
  yield takeEvery(GET_CLIENTS_LIST, onGetClientsList);
  yield takeEvery(DELETE_CLIENT, onDeleteClient);
  yield takeEvery(GET_CLIENT, onGetClient);
  yield takeEvery(UPDATE_CLIENT, onPatchClient);
  yield takeEvery(ADD_CLIENT, onAddClient);
}

export default clientsSaga;
